module.exports = __webpack_public_path__ + "static/media/logo@2x.fa2e4a47.png";